import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout/layout.vue'
import Login from '@/layout/login/Login.vue'
import Logout from '@/layout/login/Logout'
import autoLogin from '@/layout/login/misLogin.vue'
import moceanLogin from '@/layout/login/moceanLogin.vue'
import MainLayout from '@/layout/main/MainLayout.vue'

import v20Menu from '@/views/pp/20/v20Menu.vue'

import {
  getToken
} from '@/utils/token'

import { hdxCordova } from '@/mocean.js'


let MOceanID = null;

const cordovaOptions = {         
  prod_url: null,
  use_top_bar: false,
  top_bar_fix: false
};
const moceanObj = new hdxCordova(cordovaOptions)
window.moceanObj = moceanObj

Vue.use(VueRouter)
//
function getMOceanID(callback) {
    //MOceanID = null;      
    window.addEventListener("moceanready", function () {                      
      moceanObj.getUserId().then(function (res){  
         MOceanID = res;        
        //  alert("getMOceanID ROUTER: " + MOceanID);      
         callback(); // Gọi callback sau khi lấy giá trị
      } )
      .catch(function (err) {          
        MOceanID = null;
        if (err.code === 2) {
          //console.log('Key không tồn tại, gán giá trị mặc định.');  
          //alert(`Lỗi NativeStorage (Code ${err.code}): ${err.source === 'Native' ? 'Lỗi từ thiết bị' : 'Lỗi khác'}`);          
          
        } else {          
          console.error('Lỗi khác:', err);
        }
        callback(); // Gọi callback ngay cả khi có lỗi
      });
  } )  
  
  return MOceanID; // Trả về giá trị để kiểm tra
}


const createRouter = () => new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    // {
    //   path: '/pageNotFound',
    //   component: pageNotFound,
    // },
    {
      path: '/',
      // redirect: '/logout',
      component: Layout,
      children: [
        {
          path: '/v20Menu',
          name: 'v20Menu',
          component: v20Menu,
          meta: { requiresAuth: true, menu_code: 'v20Menu', menu_id: 'v20Menu', title: 'Menu', affix: false }
        },        
      //  ...pp, 
            
      ]
    }, 
    {
      path: '/moceanLogin',
      name: 'moceanLogin',
      component: moceanLogin,
    }, 
    {
      path: '/autoLogin',
      name: 'autoLogin',
      component: autoLogin,
    }, 
    {
      path: '/login',
      name: 'login',
      component: Login,
    },       
    {
      path: '/mainLayout',
      name: 'mainLayout',
      component: MainLayout
    },
    // {
    //   path: '/logout',
    //   name: 'logout',
    //   component: Logout
    // },
  ]
})

let router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  const userId = to.query.user_id
  const gotoPath = to.query.goto
  const isToken = getToken()
  const whiteList = ['/login', '/moceanLogin', '/misLogin', '/autoLogin', '/logout']
  const isWhiteListed = whiteList.includes(to.path)
  
  // console.log('✅ token from JWT:', token) 
  // Trường hợp: route không tồn tại
  if (!to.matched.length) {
    return next('/logout')
  }

  // Trường hợp: truy cập /login có user_id → chuyển hướng đến gotoPath (nếu có)
  if (to.path === '/login' && userId) {
    return next({
      path: gotoPath || '/mainLayout',
      query: { user_id: userId }
    })
  }

  // Trường hợp: truy cập autoLogin → cho qua (mặc định đã xử lý login)
  if (to.path === '/autoLogin') {
    return next()
  }

  // Trường hợp: trang trắng danh sách (login, mocean, logout...) → cho qua
  if (isWhiteListed) {
    return next()
  }

  // Trường hợp: chưa login → xử lý MOCEAN
  if (!isToken) {
    // Lấy MoceanID
    getMOceanID(() => {
      if (MOceanID) {
        return next({
          path: '/moceanLogin',
          query: { moceanID: MOceanID }
        })
      } else {
        return next('/login')
      }
    })
    return
  }

  // Mặc định: cho phép vào
  next()
})

// router.beforeEach(function (to, from, next) {

//   getMOceanID(() => {       
//   // alert(MOceanID);
//   if (MOceanID == null)  {                                 
//     next(); // Có giá trị, chạy Component Login            
//   } else {             
//     //next('/moceanLogin'); // Không có giá trị, chuyển sang Component moceanLogin
//     next({
//       path: '/moceanLogin',
//       query: { moceanID: MOceanID },
//     });
//   }
//   });

//   //  console.log('router to : ', to.matched.length)         
//   //  console.log('MOceanID : ', MOceanID)   
//   if (!to.matched.length) {    
//       next('/logout'); 
//       return; 
//       //next('/moceanLogin');
//   }   
//   else {    
//     let loginWhiteList = [...envs.framework.whiteList]
//     // Change logic here when session is applied    
//     if (!loginWhiteList.some(path => {
//             return path === to.path
//           })
//         ) 
//     {
//       if (to.query.id) {
//         console.log('Prevent next(/login) from being called when a single page is called')
//       } else {        
//        // Chưa đăng nhập
//         if (!getToken()) {
//           if (to.path !== '/login' && to.path !== '/moceanLogin') {
//             // console.log('MOceanID login router:', MOceanID);
//             if (MOceanID === null) {
//               next('/login'); // Chưa có MOceanID, đi login thường
//               // return
//             } else { 
//               // console.log('MOceanID moceanLogin router:', MOceanID); 
//               next('/moceanLogin'); // Có MOceanID, đi moceanLogin
//             }
//           } else {
//             next(); // Đã ở /login hoặc /moceanLogin, cho qua
//           }
//         } 
//         // Đã đăng nhập
//         else {
//           if (to.path === '/login' || to.path === '/moceanLogin') {
//             next('/'); // Đã đăng nhập thì không cần ở trang login
//           } else {
//             next(); // Đi tiếp đến trang đích
//           }
//         }

//       }
//     }
//     next()
//   }
// })

export default router
